import React from 'react'

import ExternalDashboard from '~/components/ExternalDashboard'
import HeaderPages from '~/components/HeaderPages'

import { Container } from './styles'

const Coupon = () => {
  return (
    <Container>
      <HeaderPages title="Métricas de cupons" />
      <ExternalDashboard dashboardId={44} />
    </Container>
  )
}

export default Coupon
